import React, { useState } from "react";
import {
  Box,
  Typography,
  Tabs,
  Tab,
  TextField,
  Button,
  Paper,
  Grid,
  InputAdornment,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider,
  Container,
} from "@mui/material";
import { CurrencyRupee, AttachMoney, Euro } from "@mui/icons-material";
import PageTitle from "../../widgets/PageTitle";
import BackBtn from "../../widgets/BackBtn";

const PricingUpdateForm = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [currency, setCurrency] = useState("INR");
  const [prices, setPrices] = useState({
    monthly: {
      basic: 19,
      growth: 49,
      enterprise: 99,
      custom: 0,
    },
    quarterly: {
      basic: 50,
      growth: 130,
      enterprise: 260,
      custom: 0,
    },
    annually: {
      basic: 180,
      growth: 450,
      enterprise: 900,
      custom: 0,
    },
  });

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleCurrencyChange = (event) => {
    setCurrency(event.target.value);
  };

  const handlePriceChange = (billingCycle, plan, value) => {
    setPrices((prev) => ({
      ...prev,
      [billingCycle]: {
        ...prev[billingCycle],
        [plan]: value,
      },
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Updated prices:", prices);
    // Add your API call or state management here
    alert("Prices updated successfully!");
  };

  const billingCycles = ["monthly", "quarterly", "annually"];
  const plans = [
    { id: "basic", label: "Basic" },
    { id: "growth", label: "Growth" },
    { id: "enterprise", label: "Enterprise" },
    { id: "custom", label: "Custom" },
  ];

  const CurrencyIcon = () => {
    switch (currency) {
      case "USD":
        return <AttachMoney fontSize="small" />;
      case "EUR":
        return <Euro fontSize="small" />;
      case "INR":
        return <CurrencyRupee fontSize="small" />;
      default:
        return <AttachMoney fontSize="small" />;
    }
  };

  return (
    <Container maxWidth="md" sx={{ mt: 3 }}>
      <BackBtn />
      <Paper variant="outlined" sx={{ p: 3, mt: 2 }}>
        <PageTitle> Update Pricing Plans</PageTitle>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Tabs value={activeTab} onChange={handleTabChange} sx={{ mb: 2 }}>
            <Tab label="Monthly" />
            <Tab label="Quarterly" />
            <Tab label="Annually" />
          </Tabs>

          <FormControl size="small" sx={{ minWidth: 120 }}>
            <InputLabel>Currency</InputLabel>
            <Select
              value={currency}
              label="Currency"
              onChange={handleCurrencyChange}
            >
              <MenuItem value="INR">INR (₹)</MenuItem>
            </Select>
          </FormControl>
        </Box>

        <Divider sx={{ mb: 3 }} />

        <form onSubmit={handleSubmit}>
          <Box sx={{ display: activeTab === 0 ? "block" : "none" }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: "medium" }}>
              Monthly Pricing
            </Typography>
            <Grid container spacing={3}>
              {plans.map((plan) => (
                <Grid item xs={12} sm={6} key={`monthly-${plan.id}`}>
                  <TextField
                    fullWidth
                    label={`${plan.label} Plan`}
                    type="number"
                    value={prices.monthly[plan.id]}
                    onChange={(e) =>
                      handlePriceChange("monthly", plan.id, e.target.value)
                    }
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <CurrencyIcon />
                        </InputAdornment>
                      ),
                    }}
                    variant="outlined"
                  />
                </Grid>
              ))}
            </Grid>
          </Box>

          <Box sx={{ display: activeTab === 1 ? "block" : "none" }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: "medium" }}>
              Quarterly Pricing
            </Typography>
            <Grid container spacing={3}>
              {plans.map((plan) => (
                <Grid item xs={12} sm={6} key={`quarterly-${plan.id}`}>
                  <TextField
                    fullWidth
                    label={`${plan.label} Plan`}
                    type="number"
                    value={prices.quarterly[plan.id]}
                    onChange={(e) =>
                      handlePriceChange("quarterly", plan.id, e.target.value)
                    }
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <CurrencyIcon />
                        </InputAdornment>
                      ),
                    }}
                    variant="outlined"
                  />
                </Grid>
              ))}
            </Grid>
          </Box>

          <Box sx={{ display: activeTab === 2 ? "block" : "none" }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: "medium" }}>
              Annual Pricing
            </Typography>
            <Grid container spacing={3}>
              {plans.map((plan) => (
                <Grid item xs={12} sm={6} key={`annually-${plan.id}`}>
                  <TextField
                    fullWidth
                    label={`${plan.label} Plan`}
                    type="number"
                    value={prices.annually[plan.id]}
                    onChange={(e) =>
                      handlePriceChange("annually", plan.id, e.target.value)
                    }
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <CurrencyIcon />
                        </InputAdornment>
                      ),
                    }}
                    variant="outlined"
                  />
                </Grid>
              ))}
            </Grid>
          </Box>

          <Box sx={{ mt: 4, display: "flex", justifyContent: "flex-end" }}>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              size="large"
              sx={{ px: 4 }}
            >
              Update Prices
            </Button>
          </Box>
        </form>
      </Paper>
    </Container>
  );
};

export default PricingUpdateForm;
